import React from 'react';
import './App.css';
import atoBG from './atoBG.png';

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <img 
          className="hero-background-image"
          src="https://scontent-hou1-1.cdninstagram.com/v/t51.82787-15/539446441_18066956507238081_4145717446163240905_n.jpg?stp=dst-jpegr_e35_tt6&_nc_cat=102&ig_cache_key=MzcwNzM5MjM1OTE5NTY2OTUzMg%3D%3D.3-ccb1-7&ccb=1-7&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjE0NDB4MTA4MC5oZHIuQzMifQ%3D%3D&_nc_ohc=ZkRYri-5fA0Q7kNvwFtUrkV&_nc_oc=AdlFtP6ZSeMegBxDfhCV5C3mkaqhgCTdcNbLiNNowuz10qu0hhEHYQkf9Kef2KQ-gVb8oJ-gnqNaRiUrOsuvXbSQ&_nc_ad=z-m&_nc_cid=1087&_nc_zt=23&se=7&_nc_ht=scontent-hou1-1.cdninstagram.com&_nc_gid=oabi9sWc2jyFItYq4CwoXw&oh=00_AfecmXPY0lFwaYUe3i8ca_TBrCdE0CrHDcEDc1f6EETLww&oe=68EE5173"
          alt="Alpha Tau Omega Chapter Brotherhood"
        />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1>Alpha Tau Omega</h1>
            <h1>Epsilon Epsilon Chapter</h1>
            <h2>Mississippi State University</h2>
            <p className="hero-subtitle">Building Better Men Since 1865</p>
            <p className="hero-description">
              Join a brotherhood dedicated to leadership, scholarship, and service. 
              Discover your potential at Mississippi State University.
            </p>
            <div className="hero-buttons">
              <a href="/contact" className="btn btn-primary">Join the Brotherhood</a>
              <a href="/events" className="btn btn-secondary">Upcoming Events</a>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="section-header">
          <h2>Our Core Values</h2>
          <p>The principles that guide our brotherhood</p>
        </div>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">🎓</div>
            <h3>Scholarship</h3>
            <p>Academic excellence is the foundation of our brotherhood. We support each other in achieving our educational goals.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">👥</div>
            <h3>Leadership</h3>
            <p>We develop leaders who make a positive impact on campus, in our communities, and in their careers.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🤝</div>
            <h3>Service</h3>
            <p>Giving back to our community is at the heart of what we do. Service is a way of life for ATO brothers.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">💎</div>
            <h3>Brotherhood</h3>
            <p>Lifelong bonds forged through shared experiences, mutual respect, and unwavering support.</p>
          </div>
        </div>
      </section>

      {/* MSU Pride Section */}
      <section className="msu-pride">
        <div className="msu-content">
          <div className="msu-text">
            <h2>Proud Bulldogs</h2>
            <p>
              As Mississippi State Bulldogs, we embody the spirit and traditions of our beloved university. 
              From cheering on our teams at Davis Wade Stadium to participating in campus traditions, 
              ATO brothers are active leaders in the MSU community.
            </p>
            <div className="msu-stats">
              <div className="stat">
                <h4>3.2</h4>
                <p>Chapter GPA</p>
              </div>
              <div className="stat">
                <h4>40+</h4>
                <p>Active Brothers</p>
              </div>
              <div className="stat">
                <h4>15+</h4>
                <p>Campus Clubs</p>
              </div>
                <div className="stat">
                    <h4>5+</h4>
                    <p>Campus Leadership Roles</p>
                </div>
                <div className="stat">
                    <h4>20+</h4>
                    <p>Local Alumni</p>
                </div>
                <div className="stat">
                    <h4>100+</h4>
                    <p>Community Service Hours</p>
                </div>
            </div>
          </div>
          <div className="msu-image">
            <img style={{ objectFit: 'fill', borderRadius: '10px' }}
              src={atoBG} 
              alt="Mississippi State Campus" 
            />
          </div>
        </div>
      </section>

      {/* Academic Excellence & Campus Involvement */}
      <section className="academics-section">
        <div className="section-header">
          <h2>Academic Excellence & Campus Leadership</h2>
          <p>ATO brothers excel in the classroom and lead on campus</p>
        </div>
        <div className="academics-grid">
          <div className="academic-card">
            <div className="academic-icon">🎓</div>
            <h3>Academic Achievements</h3>
            <ul>
              <li>Chapter GPA: 3.4+ (Above campus average)</li>
              <li>85% of brothers maintain 3.0+ GPA</li>
              <li>Dean's List honorees each semester</li>
              <li>Academic mentorship program</li>
              <li>Study groups and tutoring support</li>
            </ul>
          </div>
          <div className="academic-card">
            <div className="academic-icon">🏛️</div>
            <h3>Campus Involvement</h3>
            <ul>
              <li>Student Government Association</li>
              <li>Engineering Student Council</li>
              <li>MSU Business Council</li>
              <li>Residence Hall Association</li>
              <li>Greek Life Leadership</li>
            </ul>
          </div>
          <div className="academic-card">
            <div className="academic-icon">🏆</div>
            <h3>Recent Honors</h3>
            <ul>
              <li>Outstanding Chapter Award 2024</li>
              <li>Campus Philanthropy Recognition</li>
              <li>IFC Academic Excellence</li>
              <li>MSU Spirit Award Recipients</li>
              <li>Leadership Conference Delegates</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Current Executive Board */}
      <section className="leadership-section">
        <img src='https://scontent-hou1-1.xx.fbcdn.net/v/t39.30808-6/491313942_1464296204909053_6514694423356733502_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=833d8c&_nc_ohc=SCXtBwmOYzsQ7kNvwEA1FBE&_nc_oc=AdlMS55-TUep7SsNw4NhoVH_Ujc-MMt2TpQo_or1p8y9YsTWkAPXzD45uHVCPU_65qEIV621B9XckgGdBqty2eEA&_nc_zt=23&_nc_ht=scontent-hou1-1.xx&_nc_gid=iL4RiZtVlNWjgQj6zWnqbQ&oh=00_AfeqhGDphNu8c6IBiFmAcvS_u6-fpb4GE_10ZkZYHt3n3A&oe=68EE3FE0'
          alt="Current Executive Board" style={{ width: '400px', borderRadius: '10px', marginBottom: '1rem', alignSelf: 'center' }} />
        <div className="section-header">
          <h2 style={{ color: 'var(--fraternity-gold)' }}>Current Executive Board</h2>
          <p style={{ color: 'white' }}>Meet the brothers leading our chapter</p>
        </div>
        <div className="exec-grid">
          <div className="exec-card">
            <div className="exec-photo">
              <img src="https://scontent-hou1-1.xx.fbcdn.net/v/t39.30808-6/490756219_1464461161559224_7674692779594098763_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=833d8c&_nc_ohc=N82sh1oePSUQ7kNvwEfkhxL&_nc_oc=AdlGGip1_mnxdZLnGV4__5fgHmhBw8F7DOJ4_rkVu6oaUsotN9y6w95VAXyuy2-w9yqo_K1ycmnlV9WjoDbq94mu&_nc_zt=23&_nc_ht=scontent-hou1-1.xx&_nc_gid=uDI7wR2PX5jI0-s6f6a8iA&oh=00_Afcw651xnmzaZLa0DZnRcsm1_YEC4cZa7zLq16mzEZqYOA&oe=68EE4375" alt="Chapter President" />
            </div>
            <h3>Sean Washburn</h3>
            <p className="exec-title">President</p>
            <p className="exec-major">Broadcast Meterology, Senior</p>
            <p className="exec-bio">Leading our chapter with vision and dedication. Previously served as VP.</p>
          </div>
          <div className="exec-card">
            <div className="exec-photo">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face" alt="Vice President" />
            </div>
            <h3>Curr Vice President</h3>
            <p className="exec-title">Vice President</p>
            <p className="exec-major">Business Administration, Junior</p>
            <p className="exec-bio">Focused on member development and chapter operations. SGA Senator.</p>
          </div>
          <div className="exec-card">
            <div className="exec-photo">
              <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=face" alt="Rush Chairman" />
            </div>
            <h3>Curr Rush Chairman</h3>
            <p className="exec-title">Rush Chairman</p>
            <p className="exec-major">Communications, Sophomore</p>
            <p className="exec-bio">Leading recruitment efforts and new member education. Campus tour guide.</p>
          </div>
          <div className="exec-card">
            <div className="exec-photo">
              <img src="https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=200&h=200&fit=crop&crop=face" alt="Treasurer" />
            </div>
            <h3>Curr Treasurer</h3>
            <p className="exec-title">Treasurer</p>
            <p className="exec-major">Finance, Junior</p>
            <p className="exec-bio">Managing chapter finances and budgeting. Accounting Club President.</p>
          </div>
        </div>
      </section>

      {/* Member Testimonials */}
      <section className="testimonials-section">
        <div className="section-header">
          <h2>Brotherhood Voices</h2>
          <p>Hear from current brothers about their ATO experience</p>
        </div>
        <div className="testimonials-grid">
          <div className="testimonial-card current">
            <div className="testimonial-header">
              <img src="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=80&h=80&fit=crop&crop=face" alt="Current Member" />
              <div>
                <h4>Example Name</h4>
                <p>Computer Science, Junior</p>
                <span className="member-type">Current Brother</span>
              </div>
            </div>
            <blockquote>
              "ATO has been instrumental in my growth as a leader and student. The brotherhood support helped me maintain a 3.8 GPA while serving as treasurer and participating in hackathons. The connections I've made here will last a lifetime."
            </blockquote>
          </div>
          <div className="testimonial-card current">
            <div className="testimonial-header">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face" alt="Current Member" />
              <div>
                <h4>Example Name</h4>
                <p>Agricultural Engineering, Sophomore</p>
                <span className="member-type">Current Brother</span>
              </div>
            </div>
            <blockquote>
              "Coming from a small town in Mississippi, I was nervous about fitting in at MSU. ATO welcomed me with open arms and helped me get involved in campus life. I'm now part of the Agriculture Student Council and feel truly at home."
            </blockquote>
          </div>
          <div className="testimonial-card alumni">
            <div className="testimonial-header">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face" alt="Alumni" />
              <div>
                <h4>Example Name</h4>
                <p>Class of 2019</p>
                <span className="member-type">Alumni</span>
              </div>
            </div>
            <blockquote>
              "The leadership skills I developed in ATO directly contributed to my success as a project manager at a Fortune 500 company. The network of brothers has opened doors throughout my career. ATO taught me the value of integrity and service."
            </blockquote>
          </div>
          <div className="testimonial-card alumni">
            <div className="testimonial-header">
              <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face" alt="Alumni" />
              <div>
                <h4>Example Name</h4>
                <p>Class of 2015</p>
                <span className="member-type">Alumni</span>
              </div>
            </div>
            <blockquote>
              "ATO provided the foundation for my academic and professional success. The study groups and mentorship helped me excel in pre-med courses, and now as a practicing physician, I still rely on the leadership principles I learned as a brother."
            </blockquote>
          </div>
        </div>
      </section>

      {/* Alumni Success Stories */}
      <section className="alumni-success">
        <div className="section-header">
          <h2>Alumni Excellence</h2>
          <p style={{ color: 'white' }}>Our brothers continue to make their mark across industries</p>
        </div>
        <div className="alumni-stats-grid">
          <div className="alumni-stat-card">
            <h3>Industries</h3>
            <div className="industry-list">
              <span>Engineering</span>
              <span>Healthcare</span>
              <span>Finance</span>
              <span>Technology</span>
              <span>Education</span>
              <span>Government</span>
              <span>Agriculture</span>
              <span>Business</span>
            </div>
          </div>
          <div className="alumni-stat-card">
            <h3>Advanced Degrees</h3>
            <div className="degree-stats">
              <div className="degree-item">
                <strong>35%</strong>
                <span>Master's Degrees</span>
              </div>
              <div className="degree-item">
                <strong>15%</strong>
                <span>Doctoral Degrees</span>
              </div>
              <div className="degree-item">
                <strong>12%</strong>
                <span>Professional Degrees</span>
              </div>
              <div className="degree-item">
                <strong>8%</strong>
                <span>MBA</span>
              </div>
            </div>
          </div>
          <div className="alumni-stat-card">
            <h3>Career Highlights</h3>
            <ul className="career-highlights">
              <li>3 Fortune 500 CEOs</li>
              <li>12 Medical Doctors</li>
              <li>8 Licensed Engineers</li>
              <li>6 University Professors</li>
              <li>4 State Government Officials</li>
              <li>15+ Successful Entrepreneurs</li>
            </ul>
          </div>
        </div>
        <div className="notable-alumni">
          <h3>Recent Notable Achievements</h3>
          <div className="achievement-grid">
            <div className="achievement-item">
              <strong>Example Alumni '18</strong>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
            <div className="achievement-item">
              <strong>Example Alumni '16</strong>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
            <div className="achievement-item">
              <strong>Example Alumni '20</strong>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
            <div className="achievement-item">
              <strong>Example Alumni '17</strong>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="why-join">
        <div className="section-header">
          <h2>Why Join ATO at MSU?</h2>
          <p>Discover the opportunities that await you</p>
        </div>
        <div className="benefits-grid">
          <div className="benefit-item">
            <h3>Academic Support</h3>
            <p>Study groups, tutoring, and academic mentorship from upperclassmen and alumni.</p>
          </div>
          <div className="benefit-item">
            <h3>Leadership Opportunities</h3>
            <p>Develop leadership skills through chapter positions and campus involvement.</p>
          </div>
          <div className="benefit-item">
            <h3>Professional Network</h3>
            <p>Connect with alumni across industries who are ready to help with internships and careers.</p>
          </div>
          <div className="benefit-item">
            <h3>Social Events</h3>
            <p>Formals, tailgates, mixers, and brotherhood events that create lasting memories.</p>
          </div>
          <div className="benefit-item">
            <h3>Community Service</h3>
            <p>Make a difference through meaningful philanthropic work and community engagement.</p>
          </div>
          <div className="benefit-item">
            <h3>Lifelong Friendships</h3>
            <p>Build relationships that extend far beyond your college years.</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section" style={{ padding: '2rem', background: 'linear-gradient(135deg, var(--primary-azure) 0%, var(--azure-light) 100%)', textAlign: 'center' }}>
        <div className="cta-content">
          <h2>Ready to Join the Brotherhood?</h2>
          <p>Take the first step toward becoming an Alpha Tau Omega brother at Mississippi State University.</p>
          <div className="cta-buttons">
            <a href="/contact" className="btn btn-primary">Get in Touch</a>
            <a href="/events" className="btn btn-outline">View Rush Events</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
